import React, { useState, useRef, useEffect } from 'react';
import Proptypes from 'prop-types';
import { Tooltip } from '@fluentui/react-components';

export const TagWithTooltip = ({ content }) => {
  const [isOverflow, setIsOverflow] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const tagRef = useRef();

  useEffect(() => {
    if (tagRef.current) {
      setIsOverflow(tagRef.current.clientWidth < tagRef.current.scrollWidth);
    }
  }, []);

  return (
    <Tooltip
      content={content}
      id={content}
      relationship="description"
      withArrow
      visible={isTooltipVisible && isOverflow}
      onVisibleChange={(ev, data) => setIsTooltipVisible(data.visible)}
    >
      <span
        className="tagText"
        ref={tagRef}
      >
        {content}
      </span>
    </Tooltip>
  );
};

TagWithTooltip.propTypes = {
  content: Proptypes.string.isRequired,
};
